(function () {
  const initProductAccordion = () => {
    if (!window.jQuery) return;
    // namespaced so section reloads don't stack handlers
		$(".about__accordion-toggle").off("click.fhAcc").on("click.fhAcc", function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
  };

  const initZoomImage = () => {
    const imagesWrapper = document.querySelector('.product-media-modal__content');
    if (!imagesWrapper) return;
    const images = imagesWrapper.querySelectorAll('.js-image-zoom');

    images.forEach(el => {
      if (el.dataset.zoomBound) return;
      el.dataset.zoomBound = '1';
      el.addEventListener('click', (e) => {
        imagesWrapper.classList.toggle('zoom');
      });
    })
  };

  const init = () => {
    initProductAccordion();
    initZoomImage();
  };

  document.addEventListener('shopify:section:load', init);

  // wait for deferred jQuery, which loads after this file
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
